import { FeatureFlagConstants } from './constants/utilConstants';

interface IVariant {
  name: string;
  enabled: boolean;
  payload?: {
    type: string;
    value: string;
  };
}

interface IToggle {
  name: string;
  enabled: boolean;
  variant: IVariant;
  impressionData: boolean;
}

const getFeatureFlag = (allFlags: IToggle[] = [], flagKey: string) => {
  return allFlags.find((flag) => flag.name === flagKey);
};

/**
 * This fn returns boolean || defaultValue. Should be used when flag is simple on/off.
 * @param allFlags : Toggle[], to be passed from Zustand store.
 * @param key: Flag of interest.
 * @param defaultValue: User provided defaultValue
 * @returns: boolean || defaultValue
 */
export const isFeatureEnabled = (allFlags: IToggle[], key: string) => {
  //TODO: remove hardcode later
  if (key === FeatureFlagConstants.FEATURE_SEO_THROUGH_API) return true;
  const flag = getFeatureFlag(allFlags, key);
  return flag?.enabled ? flag.enabled : false;
};

/**
 * This fn returns object of format {enabled: boolean, payload:{...}}. This should be called when the flag
 * is config type i.e., having multiple key/values
 *
 * @param allFlags : Toggle[], to be passed from Zustand store.
 * @param flagKey: Flag of interest.
 * @param defaultValue: User provided defaultValue
 * @returns: {enabled: boolean, payload: actualPayload || defaultValue}
 */
export const getFeatureFlagConfig = (
  allFeatureFlags: IToggle[],
  flagKey: string
) => {
  const flag = getFeatureFlag(allFeatureFlags, flagKey);
  if (flag?.enabled) {
    const variant = flag.variant;
    if (variant.enabled) {
      return {
        enabled: true,
        payload: JSON.parse(variant.payload?.value as string)
      };
    }
  }
  return { enabled: false, payload: null };
};
